import { Component, Input, OnInit } from '@angular/core';
import { ShareService } from '@nttp/common-service/share-service';
import { AddBeneficiaryStep } from '../../constants/add-beneficiary-constant';
import { AddRecipientFrom } from '../../constants/add-recipient-constants';
import { NewRecipientModel } from '../../models/recipient.model';

@Component({
  selector: 'np-add-beneficiary-step',
  templateUrl: './add-beneficiary-step.component.html',
  styleUrls: ['./add-beneficiary-step.component.scss']
})
export class AddBeneficiaryStepComponent implements OnInit {

  @Input() action;
  addBeneficiaryStep = AddBeneficiaryStep;
  totalStep = [];

  constructor(
    public recipientModel: NewRecipientModel,
    private shareService: ShareService
  ) { }

  ngOnInit(): void {
    this.shareService.getAccountType().subscribe(res => {
      this.totalStep = res.fullRemitterDetailsRequired && this.action !== AddRecipientFrom.Bank
        ? [
          'Step one',
          'Step two',
          'Step three',
          'Step four'
        ] :
        [
          'Step one',
          'Step two',
          'Step three',
        ];
    });
  }
}
